<div class="input-group mb-3">
  <input type="text" class="form-control" [(ngModel)]="methodName">
  <!-- <div class="input-group-append">
    <button class="btn btn-sm btn-primary" type="button" id="customCode" (click)="openCustomCodeEditor($event)"><i class="fa fa-code"></i></button>
  </div> -->
</div>

<p-dialog header="Add Menus" [(visible)]="showMethodPopup" [style]="{width: '50vw'}" [modal]="true" [appendTo]="'body'">

  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn" (click)="closeDialog()">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="updateFieldsFoTable()">{{'SAVE' |
      translate}}</button>
  </ng-template>
</p-dialog>